import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { ExecutionResultDto } from 'src/app/_models/execution-result-model';
import { ExecutionResult } from 'src/app/_models/execution-result-enum';
import { NotificationService } from 'src/app/_services/notification.service';

export interface ConfirmDeleteByNameOptions {
  // shown in the title and the question, e.g. 'Contact Plan', 'Step', 'AI Criteria Group'
  entityName: string;
  // what the user has to type, e.g. 'contact plan name', 'criteria code'
  nameLabel: string;
  // shown when the typed value matches, e.g. 'Code' -> "✓ Code matches"
  matchLabel: string;
  // the value to type (case-sensitive, extra spaces are ignored)
  name: string;
  delete: () => Observable<ExecutionResultDto>;
}

// Delete confirmation that requires typing the exact name of the deleted item (TT-217)
@Component({
  selector: 'app-confirm-delete-by-name-modal',
  templateUrl: './confirm-delete-by-name-modal.component.html',
  styleUrls: ['./confirm-delete-by-name-modal.component.scss']
})
export class ConfirmDeleteByNameModalComponent {
  @ViewChild('confirmDeleteByNameModal', { static: true }) modal: ModalDirective;

  @Output() deleted: EventEmitter<void> = new EventEmitter<void>();

  options: ConfirmDeleteByNameOptions;
  confirmValue = '';
  isDeleting = false;

  constructor(private notificationService: NotificationService) { }

  // case-sensitive match; repeated, leading and trailing spaces are ignored because the user cannot see them
  get isMatched(): boolean {
    return !!this.options
      && ConfirmDeleteByNameModalComponent.normalize(this.confirmValue) === ConfirmDeleteByNameModalComponent.normalize(this.options.name);
  }

  private static normalize(value: string): string {
    return (value ?? '').replace(/\s+/g, ' ').trim();
  }

  open(options: ConfirmDeleteByNameOptions): void {
    this.options = options;
    this.confirmValue = '';
    this.isDeleting = false;
    this.modal.show();
  }

  delete(): void {
    if (!this.isMatched || this.isDeleting) {
      return;
    }

    this.isDeleting = true;

    this.options.delete().subscribe({
      next: (executionResultDto: ExecutionResultDto) => {
        this.isDeleting = false;

        if (executionResultDto.executionResult === ExecutionResult.success) {
          this.notificationService.showSuccess(executionResultDto.message);
          this.modal.hide();
          this.deleted.emit();
        } else {
          this.notificationService.showError(executionResultDto.message);
        }
      },
      // the error message is shown by the global HTTP interceptor
      error: () => this.isDeleting = false
    });
  }
}
